import { useState, useEffect } from "react";
import { useGetFirmLogReportMutation } from "../store";
import { GenerateFormattedDate } from "../Components/Utils/Date/GenerateFormattedDate";
import { toScopeFirmOption } from "./useFirmScopeSelection";

export const useFirmReportData = (id, token) => {
  const [info, setInfo] = useState(false);
  const [input, setInput] = useState({
    id,
    token,
    type: "",
    createdInfo: "",
    createdInfoSecond: "",
    firmIds: [],
  });
  const [filterType, setFilterType] = useState("Day");
  const [date, setDate] = useState(new Date());
  const [dateSecond, setDateSecond] = useState(new Date());
  const [paginationNumber, setPaginationNumber] = useState(1);
  const [getReport, { data, isFetching, isLoading, isError }] =
    useGetFirmLogReportMutation();
  // Alt firma kapsamı — VARSAYILAN: firma + TÜM alt firmaları. `input.firmIds`
  // BOŞ gidince sunucu tüm ağacı kullanır (bkz. firm-log.controller).
  // Seçici seçenekleri yanıttaki `firms` listesinden kurulur; kapsam
  // daraltılsa bile sunucu izinli firmaların TAMAMINI döndürür.
  const [firmOptions, setFirmOptions] = useState([]);
  const [Datas, setDatas] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [prevInputType, setPrevInputType] = useState(input.type);

  useEffect(() => {
    if (input.type !== prevInputType) {
      setInfo(false);
      setDatas([]);
    } else {
      setDatas(
        data?.data?.filter((item) => item.logs && item.logs.length > 0) || []
      );
    }
    setPrevInputType(input.type);
  }, [data, input.type]);

  // id/token hook ilk mount'ta undefined gelebilir (firma sonradan yüklenir);
  // senkron tutulmazsa istek id'siz gider ve server 400 döner.
  useEffect(() => {
    setInput((prev) => ({ ...prev, id, token }));
  }, [id, token]);

  useEffect(() => {
    setInput((prev) => ({ ...prev, createdInfo: GenerateFormattedDate(date) }));
  }, [date]);

  useEffect(() => {
    setInput((prev) => ({
      ...prev,
      createdInfoSecond: GenerateFormattedDate(dateSecond),
    }));
  }, [dateSecond]);

  const handleGetLogData = () => {
    if (input.createdInfo && input.type) {
      setDatas([]);
      getReport(input);
    }
  };

  const handleFilterType = (type) => {
    setFilterType(type);
  };

  const serverFirms = data?.firms;
  useEffect(() => {
    if (!Array.isArray(serverFirms) || serverFirms.length === 0) return;
    setFirmOptions(
      serverFirms.map(toScopeFirmOption),
    );
  }, [serverFirms]);

  /** Seçiciden gelen firma listesi; boş = tüm ağaç. */
  const setFirmIds = (ids) => {
    setInput((prev) => ({ ...prev, firmIds: Array.isArray(ids) ? ids : [] }));
  };

  return {
    info,
    setInfo,
    input,
    setInput,
    filterType,
    setFilterType,
    date,
    setDate,
    dateSecond,
    setDateSecond,
    paginationNumber,
    setPaginationNumber,
    Datas,
    isFetching,
    isLoading,
    isError,
    selectedDate,
    setSelectedDate,
    handleGetLogData,
    handleFilterType,
    firmOptions,
    setFirmIds,
  };
};
